"use client";

import { useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  logo: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-09-at-09.09.01-1.png?v=gl8fzdsx0w7",
  quote: "Stiamo lavorando per trovare nuovi partner con cui collaborare...",
  clientName: "Coming soon..."
}, {
  id: 2,
  logo: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-04-at-15.10.53.png?v=ujfhl269qg",
  quote: "\"La mia visibilità sui social è migliorata sensibilmente grazie a loro. Il team è molto flessibile\"",
  clientName: "Daniele A. - CEO di Ristosubito.com"
}, {
  id: 3,
  logo: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-09-at-09.09.01-1.png?v=zft7nr1l03",
  quote: "Stiamo lavorando per trovare nuovi partner con cui collaborare...",
  clientName: "Coming soon..."
}, {
  id: 4,
  logo: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-09-at-09.09.01-1.png?v=8uq76dlpt4o",
  quote: "Stiamo lavorando per trovare nuovi partner con cui collaborare...",
  clientName: "Coming soon..."
}, {
  id: 5,
  logo: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-09-at-09.09.01-1.png?v=o3139yjzss",
  quote: "Stiamo lavorando per trovare nuovi partner con cui collaborare...",
  clientName: "Coming soon..."
}];
export default function INostriClienti() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const [api, setApi] = useState<CarouselApi>();
  useEffect(() => {
    if (!api) return;
    let interval: NodeJS.Timeout;
    let isHovered = false;
    const startAutoplay = () => {
      interval = setInterval(() => {
        if (!isHovered) {
          api.scrollNext();
        }
      }, 5000);
    };
    const stopAutoplay = () => {
      clearInterval(interval);
    };
    const handleMouseEnter = () => {
      isHovered = true;
      stopAutoplay();
    };
    const handleMouseLeave = () => {
      isHovered = false;
      startAutoplay();
    };
    const carouselElement = api.rootNode();
    carouselElement.addEventListener("mouseenter", handleMouseEnter);
    carouselElement.addEventListener("mouseleave", handleMouseLeave);
    startAutoplay();
    return () => {
      stopAutoplay();
      carouselElement.removeEventListener("mouseenter", handleMouseEnter);
      carouselElement.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [api]);
  return <section ref={ref} className={`py-16 bg-light-background transition-all duration-[var(--duration-medium)] ease-[var(--ease-scroll)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto px-4 max-w-5xl">
        <h2 className="text-4xl font-display font-bold text-center text-foreground-light mb-12">
          I nostri clienti
        </h2>

        <Carousel setApi={setApi} opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="md:basis-1/2 lg:basis-1/3">
                <Card className="h-full shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] border border-border">
                  <CardContent className="flex flex-col items-center justify-between h-full p-6 text-center">
                    <div className="mb-4 flex items-center justify-center h-16">
                      <img src={testimonial.logo} alt={`Logo ${testimonial.clientName}`} className="max-h-full max-w-full object-contain opacity-80 hover:opacity-100 transition-opacity duration-[var(--duration-fast)]" />
                    </div>
                    <blockquote className="text-foreground-light text-base italic mb-4 flex-grow">
                      "{testimonial.quote}"
                    </blockquote>
                    <cite className="text-sm font-semibold text-primary not-italic">
                      {testimonial.clientName}
                    </cite>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
          <div className="relative mt-8 flex justify-center gap-4">
            <CarouselPrevious className="static translate-y-0 opacity-80 hover:opacity-100 transition-opacity duration-[var(--duration-fast)]" />
            <CarouselNext className="static translate-y-0 opacity-80 hover:opacity-100 transition-opacity duration-[var(--duration-fast)]" />
          </div>
        </Carousel>
      </div>
    </section>;
}